import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

const MentionsLegales = () => {
  return (
    <div className="py-14 sm:py-18 lg:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 
          className="text-4xl sm:text-5xl font-bold text-[#2B2B2B] mb-8"
          style={{ fontFamily: 'Space Grotesk, sans-serif' }}
        >
          Mentions Légales
        </h1>
        
        <Card className="border-slate-200/70">
          <CardContent className="p-8 sm:p-12 prose prose-slate max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#2B2B2B] mb-4">1. Éditeur du site</h2>
              <p className="text-slate-700 leading-relaxed">
                Le site <strong>Rénovation de Salle de Bains</strong> est édité et exploité par:
              </p>
              <div className="bg-slate-50 p-6 rounded-lg mt-4">
                <p className="text-slate-700 mb-2"><strong>Homely Solutions</strong></p>
                <p className="text-slate-600">Suisse</p>
              </div>
              <p className="text-slate-700 leading-relaxed mt-4">
                <strong>Rénovation de Salle de Bains</strong> est une marque et un service appartenant à <strong>Homely Solutions</strong>.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#2B2B2B] mb-4">2. Activité</h2>
              <p className="text-slate-700 leading-relaxed">
                Rénovation de Salle de Bains propose des services de rénovation de salles de bains en Suisse romande, incluant:
              </p>
              <ul className="list-disc list-inside text-slate-700 space-y-2 mt-4">
                <li>Rénovation complète de salle de bains</li>
                <li>Rénovation partielle</li>
                <li>Carrelage et revêtements</li>
                <li>Installation de sanitaires</li>
                <li>Plans 3D et projections photo-réalistes</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#2B2B2B] mb-4">3. Hébergement</h2>
              <p className="text-slate-700 leading-relaxed">
                Le site est hébergé par des services d'hébergement web professionnels conformément aux standards de l'industrie.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#2B2B2B] mb-4">4. Protection des données personnelles</h2>
              <h3 className="text-xl font-semibold text-[#2B2B2B] mb-2">4.1. Collecte des données</h3>
              <p className="text-slate-700 leading-relaxed mb-4">
                Lors de votre demande de devis, nous collectons les informations suivantes:
              </p>
              <ul className="list-disc list-inside text-slate-700 space-y-2 mb-4">
                <li>Nom et prénom</li>
                <li>Adresse email</li>
                <li>Téléphone (optionnel)</li>
                <li>Localisation du projet</li>
                <li>Détails du projet de rénovation</li>
              </ul>
              
              <h3 className="text-xl font-semibold text-[#2B2B2B] mb-2">4.2. Utilisation des données</h3>
              <p className="text-slate-700 leading-relaxed mb-4">
                Vos données personnelles sont utilisées uniquement pour:
              </p>
              <ul className="list-disc list-inside text-slate-700 space-y-2 mb-4">
                <li>Traiter votre demande de devis</li>
                <li>Vous contacter concernant votre projet</li>
                <li>Améliorer nos services</li>
              </ul>
              
              <h3 className="text-xl font-semibold text-[#2B2B2B] mb-2">4.3. Protection et confidentialité</h3>
              <p className="text-slate-700 leading-relaxed mb-4">
                Vos données sont stockées de manière sécurisée et ne sont <strong>jamais partagées avec des tiers</strong>
                à des fins commerciales. Elles sont conservées uniquement pour la durée nécessaire au traitement de votre demande
                et à la réalisation éventuelle des travaux.
              </p>
              
              <h3 className="text-xl font-semibold text-[#2B2B2B] mb-2">4.4. Vos droits</h3>
              <p className="text-slate-700 leading-relaxed mb-4">
                Conformément à la législation suisse sur la protection des données (LPD), vous disposez des droits suivants:
              </p>
              <ul className="list-disc list-inside text-slate-700 space-y-2">
                <li>Droit d'accès à vos données personnelles</li>
                <li>Droit de rectification de vos données</li>
                <li>Droit de suppression de vos données</li>
                <li>Droit d'opposition au traitement</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#2B2B2B] mb-4">5. Cookies</h2>
              <p className="text-slate-700 leading-relaxed">
                Ce site utilise des cookies techniques nécessaires à son bon fonctionnement.
                Aucun cookie de tracking ou publicitaire n'est utilisé.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#2B2B2B] mb-4">6. Propriété intellectuelle</h2>
              <p className="text-slate-700 leading-relaxed">
                L'ensemble du contenu de ce site (textes, images, logos, structure) est la propriété de <strong>Homely Solutions</strong>
                et est protégé par les lois sur la propriété intellectuelle. Toute reproduction, même partielle, est interdite sans autorisation préalable.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#2B2B2B] mb-4">7. Responsabilité</h2>
              <p className="text-slate-700 leading-relaxed">
                Nous nous efforçons de maintenir les informations du site à jour et exactes.
                Toutefois, nous ne pouvons garantir l'exactitude, la complétude ou l'actualité des informations diffusées sur le site.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#2B2B2B] mb-4">8. Liens externes</h2>
              <p className="text-slate-700 leading-relaxed">
                Ce site peut contenir des liens vers des sites externes. Nous n'avons aucun contrôle sur le contenu de ces sites
                et ne pouvons être tenus responsables de leur contenu.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#2B2B2B] mb-4">9. Contact</h2>
              <p className="text-slate-700 leading-relaxed">
                Pour toute question concernant ces mentions légales ou pour exercer vos droits relatifs à vos données personnelles,
                vous pouvez nous contacter via notre formulaire de devis.
              </p>
            </section>

            <div className="mt-12 pt-8 border-t border-slate-200">
              <p className="text-sm text-slate-500">
                Dernière mise à jour : Mars 2026<br />
                <strong>Homely Solutions</strong> - Suisse
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default MentionsLegales;